import { RootStore } from "./rootStore";
import { reaction, runInAction, makeAutoObservable } from "mobx";
import agent from "../api/agent";
import {
  getCompanySqlite,
  initializeDb,
  updateCompany,
} from "../sqlite/utilities";
import { applyCompanyTheme, ICompany, ICompanyRegistrationSettings, ILanguage } from "../models/company";
import cmsThemes, {
  ICompanyTheme,
  ITheme,
} from "../models/theme";
import {
  IBrowserPageContent,
  IGalleryElement,
  IPlayerContent,
} from "../models/content";
import { IToolbar, Toolbar } from "../models/toolbar";
import { IGalleryFile, PlayerBrowsePageDto, PresentationDetailDto } from "../models/dto";
import { ISpeakerContent } from "../models/podium";
import { IGuestContent } from "../models/guest";
import { toast } from "react-toastify";
import filesystem from "../filesystem/filesystem";
import { ITenant } from "../models/tenant";
import { Capacitor } from "@capacitor/core";
import { CancelTokenSource } from "axios";
import { t } from "i18next";
import { setDefaultCompanyLanguage } from "../localization/localization";

export default class CommonStore {
  rootStore: RootStore;

  CancelTokenSource: CancelTokenSource| null = null;

  CancelTokenSourceDownload: CancelTokenSource| null = null;

  IsGallery: boolean= false;

  galleryCancelToken : CancelTokenSource[]= [];

  changePageGallery: boolean= false;

  correctPassword: string = "1234";


  
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    window.addEventListener("online", () => (this.isOnline = true));
    window.addEventListener("offline", () => (this.isOnline = false));

    // reaction(
    //   () => this.token,
    //   (token) => {
    //     if (token) {
    //       window.localStorage.setItem("jwt_p", token);
    //     } else {
    //       window.localStorage.removeItem("jwt_p");
    //     }
    //   }
    // );

    reaction(
      () => this.company,
      async (company) => {
        if (company && company.name) {
         await this.loadThemeCompany(company);
         await applyCompanyTheme(company, this.isNativeApp);
         await setDefaultCompanyLanguage(company.languageDefault);
         this.loadLanguages();
        }
      }
    );
  }

  loadThemeCompany = async(Company: ICompany) => {
    try {
      
      if (!this.isNativeApp)
      {
        console.log("Load theme company ONLINE");

        if (Company) {
          this.rootStore.commonStore.companyTheme = {
            displayTenantNameInTenantList: Company.displayTenantNameInTenantList ?? false,
            oldToolbar:  false,
            hiddenEndHour:  Company.hiddenEndHour ?? false,
            hiddenDuration:  Company.hiddenDuration ?? false,
            hiddenNumDoc:  Company.hiddenNumDoc ?? false,
            hiddenStartDate:  Company.hiddenStartDate ?? false,
            hiddenEndDate:  Company.hiddenEndDate ?? false,
            hiddenStartHour:  Company.hiddenStartHour ?? false,
            sidebarButtonBorder:  Company.sidebarButtonBorder === "none" || 
                                  Company.sidebarButtonBorder === "rounded" || 
                                  Company.sidebarButtonBorder === "squared" ? 
                                  Company.sidebarButtonBorder : undefined,

          };
        }
      }
    else { 
      console.log("Load theme company OFFLINE");
                       
      await filesystem.Read.textFile("img/companies/themeCompany.json").then((textFile) => {
        //console.log("TEMA COMPANY CARICATO: " + textFile);
        
        let jsonData;

          if (textFile)
            jsonData = JSON.parse(textFile);

          const myMap =  new Map<string, ICompanyTheme>();
          Object.entries(jsonData).forEach(([key, value]) => {
            myMap.set(key, value as ICompanyTheme);
          });
    
          if(myMap.has(Company.name)){
            this.rootStore.commonStore.companyTheme= myMap.get(Company.name);
          } else {
            this.rootStore.commonStore.companyTheme= myMap.get("default");
          }
      }).catch(() => toast.error("Errore caricamento tema company " + Company.name));
        
    }

   } catch (error) {
       console.log(error);
    }
   }
  
  loadThemeTenant= async( theme : string)=>{

    try{
      const ts = new Date().getMilliseconds();
        const xhr = new XMLHttpRequest();
        const path=`${process.env.REACT_APP_THEME_PATH}themesPlayer/${theme}/theme.css?ts=${ts} `
      
        xhr.open('GET', path, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
             const link = document.createElement('link');
            link.href = path;
            link.rel = 'stylesheet';
            document.head.appendChild(link);
          }
        };
        xhr.send();
    }
     catch(error){
  toast.error("Errore caricamenbto tema tenant " + theme);
 }
 }

 loadOfflineThemeTenant= async(currentTenant: ITenant)=>{

  try{
     await filesystem.GetLocalUrl.tenantCssTheme(currentTenant, "theme.css")
        .then((url) => {
          console.log("TEMA CARICATO: " + url);          
          var themeUrl = Capacitor.convertFileSrc(url);
          
          const elementToremove = document.getElementById("currentOfflineThemeLink");

          if (elementToremove)
            elementToremove?.remove();
          
          const currentOfflineThemeLink = document.createElement('link');
          currentOfflineThemeLink.href = themeUrl;
          currentOfflineThemeLink.rel = 'stylesheet';
          currentOfflineThemeLink.id = "currentOfflineThemeLink";

          document.head.appendChild(currentOfflineThemeLink);
        })
        .catch(() => toast.error("Errore caricamento tema tenant " + currentTenant.theme));
  }
   catch(error){
    toast.error("Errore caricamento tema tenant " + currentTenant.theme);
  }
}
  company: ICompany | null = null;
  loadingCompany: boolean = true;
  // token: string | null = window.localStorage.getItem("jwt_p");
  theme: ITheme | undefined = cmsThemes.get("template");
  companyTheme: ICompanyTheme | undefined ;
  appLoaded = false;
  nativeAppLoaded = false;
  dashboardLoaded = false;
  tenantLayoutLoaded = false;
  companyLoaded = false;
  loadingLanguages: boolean = false;
  allLanguages: ILanguage[] = [];
  selectedLanguageId: number | undefined = undefined;
  toolbar: IToolbar | null = null;
  isNativeApp: boolean = process.env.REACT_APP_IS_NATIVE_APP
    ? process.env.REACT_APP_IS_NATIVE_APP.toLocaleLowerCase() === "true"
    : false;
  isOnline: boolean = navigator.onLine;
  isOfflineModeEnabled: boolean = false;
  isAutoSyncEnabled: boolean = false;

  messageErrorScope: string= "";
  messageErrorAction: string=""

  //REFACTORING GALLERY
  currentBrowsePageContent: IBrowserPageContent | null = null;
  currentGalleryFile: IGalleryFile | null = null;
  currentGalleryPage: number = 0;
 loadingCompanyRegistration : boolean= true;
 companyRegistrationSettings:  ICompanyRegistrationSettings| null= null
  get everythingLoaded() {
    return this.appLoaded && this.nativeAppLoaded && this.companyLoaded;
  }

  get isToShowEditTab() {
    let retVal = false;
    if (this.toolbar) {
      const allValues = Object.values(this.toolbar.tools);
      retVal = allValues.some((x) => x);
    }
    return retVal;
  }

  getCompany = async (companyId: string) => {
    this.loadingCompany = true;
    try {
      let company: ICompany | null = null;
      if (this.isNativeApp && !this.isOnline)
        company = await getCompanySqlite();
      else {
        company = await agent.Company.details(companyId);
        if (this.isNativeApp){//inserito per far funzionare Guest
          if (company) await updateCompany(company);
        }
        
      }

      runInAction(() => {
        this.company = company;
        this.loadingCompany = false;
      });

      return company;
    } catch (error) {
      runInAction(() => {
        this.loadingCompany = false;
      });
    }
  };

  ResetmessageErrorUploadedFiles= async ()=> {

    this.messageErrorScope="";
    this.messageErrorAction="";
  }

  // setToken = (token: string | null) => {
  //   this.token = token;
  // };

  setCompanyLoaded = () => {
    this.companyLoaded = true;
  };

  setAppLoaded = () => {
    this.appLoaded = true;
  };

  setNativeAppLoaded = () => {
    this.nativeAppLoaded = true;
  };

  InitNativeApp = async () => {
    if (this.isNativeApp) {
      if (!(await initializeDb())) console.log("Errore database app");
      if (navigator.onLine)
        await filesystem.Download.companyThemeCss("themeCompany.json"); 
    }
  };

  updateOfflineModeEnabled = (value: boolean) => {
    if (process.env.REACT_APP_FORCE_OFFLINE) {
      this.isOfflineModeEnabled =
        process.env.REACT_APP_FORCE_OFFLINE.toLocaleLowerCase() === "true";
    } else this.isOfflineModeEnabled = this.isNativeApp ? value : false;
  };

  setTenantLayoutLoaded = () => {
    this.tenantLayoutLoaded = true;
  };

  setDashboardLoaded = () => {
    this.dashboardLoaded = true;
  };

  loadLanguages = async () => {
    this.loadingLanguages = true;
    try {
      const languages = await agent.Company.languages();
      runInAction(() => {
        this.allLanguages = languages;
        this.loadingLanguages = false;
      });
      return languages;
    } catch (error) {
      runInAction(() => {
        this.loadingLanguages = false;
      });
    }
  };

  setSelectedLanguageId = (langIg: number) => {
    this.selectedLanguageId = langIg;
  };

  loadToolbar = async (contentId: number) => {
    try {
      const toolbar = await agent.Player.toolbar(contentId);
      runInAction(() => {
        this.toolbar = toolbar;
        this.rootStore.screensStore.setScreensSettings(toolbar.screensSettings);
      });
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.toolbar = new Toolbar();
      });
      throw error;
    }
  };

  setContentNote = (value: boolean) => {
    if (this.toolbar) {
      const btn = this.toolbar.noteButtons.filter(
        (x) => x.type === "content"
      )[0];
      if (btn) {
        btn.hasExistingNote = value;
      }
    }
  };

  setFileNote = (fileId: number, value: boolean) => {
    if (this.toolbar && this.currentBrowsePageContent) {
      const btn = this.toolbar.noteButtons.filter((x) => x.type === "file")[0];
      if (btn) {
        let element = this.currentBrowsePageContent.items.filter(
          (x) => x.fileId === fileId
        )[0];
        if (element) element.hasNote = value;
      }
    }
  };

  loadDownloadableFile = async (url: string) => {
    try {
      this.abortRequest(this.CancelTokenSourceDownload);
      const result = await agent.Content.download(url);
      this.CancelTokenSourceDownload= result.sourcecancellation;
      return result.result;
    } catch (error) {
      console.log(error);
      //throw error;
    }
  };

  loadDownloadableCabolo = async (url: string) => {
    try {
      this.abortRequest(this.CancelTokenSourceDownload);
      const result = await agent.Cabolo.download(url);
      runInAction(() => {
        this.CancelTokenSourceDownload = result.sourcecancellation;
         })
      return result.result;
    } catch (error) {
      console.log(error);
      //throw error;
    }
  };

  customWatermark = async (contentId: number) => {
    try {
      await agent.Content.customWatermark(contentId);
      if (
        this.currentBrowsePageContent &&
        this.currentBrowsePageContent.contentId === contentId
      ) {
        if (this.toolbar) {
          const btn = this.toolbar.downloadButtons.filter(
            (x) => x.type === "custom"
          )[0];
          if (btn) {
            btn.disabled = true;
            btn.inProgress = true;
          }
        }
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  handleCustomWatermarkNotification = (contentId: number) => {
    if (
      this.currentBrowsePageContent &&
      this.currentBrowsePageContent.contentId === contentId
    ) {
      if (this.toolbar) {
        const btn = this.toolbar.downloadButtons.filter(
          (x) => x.type === "custom"
        )[0];
        if (btn) {
          btn.disabled = false;
          btn.inProgress = true;
        }
      }
    }
  };


  setAutoSync = (value: boolean) => {
    this.isAutoSyncEnabled = value;
  };

  setArchiveBrowsePageDetails = (browsePageDetails: PlayerBrowsePageDto) => {
    this.currentBrowsePageContent = {
      typology: browsePageDetails.typology,
      items: browsePageDetails.galleryElements,
      contentId: browsePageDetails.contentId,
      title: { document: browsePageDetails.documentName, source: browsePageDetails.sourceName },
      languages: {
        availabeLanguages: browsePageDetails.availableLanguages,
        languageId: browsePageDetails.languageId,
      },
    };
  };

  //REFACTORING GALLERY
  setMeetingBrowsePageContent = (content: IPlayerContent) => {
    const { contentData, documentName, sourceName } = content;
    let itemsCount = contentData.convertedPagesNumber;
    let items: IGalleryElement[] = contentData.files.map((element, index) => ({
      type:   (element.type=="video" || contentData.typology=="video" ) ?"video" : "image",
      original:   (element.type=="video" || contentData.typology=="video")
                        ?`${contentData.baseUrl + element.fileId}?format=mp4`
                        : `${contentData.baseUrl + element.fileId}`,
      thumbnail: `${contentData.baseUrl + element.fileId}?format=th`,
      totalNumber: itemsCount,
      index: index + 1,
      fileId: element.fileId,
      hasNote: element.hasNote,
    }));

    this.currentBrowsePageContent = {
      typology: contentData.typology,
      items: items,
      contentId: contentData.id,
      title: { document: documentName, source: sourceName },
      languages: {
        availabeLanguages: content.availableLanguages,
        languageId: content.languageId,
      },
    };
  };

  setBoardBrowsePageContent = (content: IPlayerContent) => {
    this.setMeetingBrowsePageContent(content);
  };

  setRepositoryBrowsePageContent = (content: PresentationDetailDto) => {
    const { contentDataPresentation, title } = content;
    let items: IGalleryElement[] = contentDataPresentation.map((element) => ({
      type: element.isVideo ? "video" : "image",
      original: element.original,
      thumbnail: element.thumbnail,
      totalNumber: element.totalNumber,
      index: element.index,
      fileId: element.fileId,
      hasNote: false,
    }));

    this.currentBrowsePageContent = {
      items: items,
      title: { document: title, source: "" },
      typology: ""
    };
  };

  setSpeakerBrowsePageContent = (content: ISpeakerContent) => {
    let items: IGalleryElement[] = content.files.map((element, index) => ({
      type:  content.typology==="video" ? "video" : element.type,
      // original: `${content.baseUrl}${element.fileId}${
      //   element.type === "video" ? "?format=mp4" : ""
      // }`,
      original:   `${content.baseUrl}${element.fileId}${
       (  content.typology==="video"|| element.type === "video" ) ? "?format=mp4" : ""
      }`,
      thumbnail: `${content.baseUrl}${element.fileId}?format=th`,
      totalNumber: content.files.length,
      index: index + 1,
      fileId: element.fileId,
      hasNote: element.hasNote,
    }));

    this.currentBrowsePageContent = {
      items: items,
      title: { document: content.name, source: "" },
      typology: content.typology
    };
  };

  setGuestBrowsePageContent = (content: IGuestContent) => {
    let items: IGalleryElement[] = content.files.map((element, index) => ({
      type: element.type,
      original: `${content.baseUrl}${element.fileId}${
        element.type === "video" ? "?format=mp4" : ""
      }`,
      thumbnail: `${content.baseUrl}${element.fileId}?format=th`,
      totalNumber: content.files.length,
      index: index + 1,
      fileId: element.fileId,
      hasNote: element.hasNote,
    }));

    // parte commentata è sembra un vecchio residuo e mandava in errore il global guest

    // let guestTheme = cmsThemes.get(content.guestTheme);
    // this.rootStore.commonStore.theme = guestTheme ? guestTheme : cmsThemes.get("default");
    console.log("here")

    this.currentBrowsePageContent = {
      items: items,
      title: { document: content.name, source: "" },
      typology: "",
    };
  };

  setGalleryPage = (index: number, itemsCount: number) => {

    // toast.error("setGalleryPage");
    this.changePageGallery= true;
    if (index < 0) this.currentGalleryPage = 0;
    else if (index > itemsCount - 1) this.currentGalleryPage = itemsCount - 1;
    else this.currentGalleryPage = index;
  };

  setGalleryFile = (file: IGalleryFile) => {
    this.currentGalleryFile = file;
  };

  resetBrowsePage = () => {
    this.currentBrowsePageContent = null;
    this.currentGalleryFile = null;
    this.toolbar = null;
    this.currentGalleryPage = 0;
  };


  loadCompanyRegistrationSettings = async (companyId: number) => {
    this.loadingCompanyRegistration= true;
      try {
        
        const registrationSettings = await agent.Company.registrationSettings(companyId);
        runInAction(() => {
            this.rootStore.commonStore.allLanguages= registrationSettings.allLanguages
           this.companyRegistrationSettings= registrationSettings;
          this.loadingCompanyRegistration= false;
        })
        return registrationSettings;
      } catch (error) {
        console.log(error);
      
      }
    };
   
    abortRequest = (CancelTokenSource : CancelTokenSource | null) => {
      if (CancelTokenSource) {
        // toast.error("CAncellation");
       CancelTokenSource.cancel('Richiesta annullata manualmente.');
        console.log('Annullata la richiesta in corso');
      }
    };

    cancelDownloadFile = async () => {
      try {
      // per stoppare un download di un file
        this.abortRequest( this.CancelTokenSourceDownload);
     } catch (error) {
        console.log(error);
      }
    };
 
     setIsGallery = async ( isgallery: boolean) => {
      //  toast.info("SetIsGallery");
       this.IsGallery= isgallery;
     }

      setGalleryCancelToken = async (CancelTokenSource : CancelTokenSource)=> {
           // creare array 
           this.galleryCancelToken.push(CancelTokenSource);
      }

      // abortGalleryTokenRequest = async ()=> {
      //       this.galleryCancelToken.forEach(cancelTokenSource => {
      //         this.abortRequest(cancelTokenSource);
      //     });
      //   }  


       abortGalleryTokenRequest =  () => {
        for (let i = 0; i < this.galleryCancelToken.length; i++) {
            const cancelTokenSource = this.galleryCancelToken[i];
             this.abortRequest(cancelTokenSource);
            // Rimuovi l'elemento dall'array
            this.galleryCancelToken.splice(i, 1);
            // Decrementa l'indice per compensare la rimozione dell'elemento
            i--;
        }
    };

    //  isCancelGalleryToken = async ()=> {
    //    var currentPage = this.currentGalleryPage;
    //    if(this.currentBrowsePageContent){
    //    var number_page = this.currentBrowsePageContent.items.length;
    //    if(this.galleryCancelToken.length>= number_page){

    //    }
    //    }else{

    //    }
    //  }
 

}
